
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serien/[slug]",
      function () {
        return require("private-next-pages/serien/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serien/[slug]"])
      });
    }
  